import styled, { css } from 'styled-components'

import { device } from '~/styles/device'

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    /* flex-wrap: wrap; */
    align-items: center;
    padding: ${theme.spacings.xxsmall};

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.tertiary};
    }

    line-height: 1.125;

    background-color: ${theme.colors.white};

    transition: background-color 0.3s ease-in-out;

    &:hover {
      background-color: ${theme.colors.light};
    }
  `}
`

export const Image = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;

    min-width: 3rem;
    max-width: 3rem;
    max-height: 3rem;
    margin-right: ${theme.spacings.medium};
    border: 0.25rem solid ${theme.colors.light};

    border-radius: ${theme.border.radius.large};

    background-color: ${theme.colors.light};

    .without-image {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 3rem;
      height: 3rem;

      background-color: ${theme.colors.light};
      color: ${theme.colors.primaryLighten30};
    }

    img {
      mix-blend-mode: multiply;
      max-width: 3rem;
      max-height: 3rem;
      object-fit: cover;
    }
  `}
`

export const Infos = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-wrap: wrap;
    flex: 1;
    margin-top: 0.25rem;

    > div {
      display: flex;

      &.mainInfo {
        align-items: center;
      }
    }

    .secondary {
      > * {
        &:not(:first-child) {
          margin-left: ${theme.spacings.xxxsmall};
        }
      }
    }
  `}
`

export const Name = styled.div`
  ${({ theme }) => css`
    font-weight: ${theme.font.bold};
    text-transform: capitalize;
  `}
`

export const InfoItem = styled.div`
  ${({ theme }) => css`
    display: inline-flex;
    align-items: center;

    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.xsmall};

    transition: all 0.3s ease-in-out;

    flex: 1 1 100%;

    &:first-child {
      margin-right: 4px;
    }

    &:hover {
      color: ${theme.colors.primary};
    }

    * {
      font-size: ${theme.font.sizes.xsmall};
    }

    > svg {
      margin-right: ${theme.spacings.tiny};
    }
  `}
`

export const Action = styled.aside`
  ${({ theme }) => css`
    font-weight: ${theme.font.bold};
    text-transform: capitalize;
    margin-left: 0.5rem;

    @media ${device.laptop} {
      margin-left: 1rem;
    }
  `}
`

export const SelectedOnSearch = styled.div`
  .selectedItem {
    display: flex;
  }
  .removeItem {
    display: none;
  }

  ${Container}:hover & > {
    .selectedItem {
      display: none;
    }
    .removeItem {
      display: flex;
    }
  }
`
